<template>
	<span v-if="kind === 'yn'" class="yn" :class="value">{{ label }}</span>
	<span v-else class="status" :class="'st-' + tone"><span class="dot"></span>{{ label }}</span>
</template>

<script>
export default {
	name: 'PeStatus',
	props: {
		tone: { type: String, default: 'grey' }, // green, amber, purple, blue, red, grey, dash
		label: { type: String, default: '' },
		kind: { type: String, default: 'status' }, // 'yn' renders the small .yn badge instead
		value: { type: String, default: 'no' }, // yes, no, warn, inc, blue (kind="yn" only)
	},
}
</script>
